import { Box, Title, Text } from '@nerdwallet/currency';

import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import styles from './impact-pyramid.module.less';
import PyramidItemBadge from './pyramid-item-badge';
import items from '../../../lib/impact-pyramid-items';

const ImpactPyramid = () => {
  return (
    <Box className={styles.container}>
      <Title className={styles.title} size="small" align="center">
        NerdWallet’s Impact
      </Title>
      <ul
        id="pyramid-items"
        display="flex"
        flexWrap="wrap"
        flexDirection="row"
        className={classNames([
          classes('display-flex', 'flex-wrap', 'flex-direction-row'),
        ])}
      >
        {items.map((item) => (
          <li key={item.id} className={styles.cardContainer}>
            <PyramidItemBadge item={item} />
            <Box
              borderRadius="2"
              className={classNames([
                styles.descriptionBox,
                styles.descriptionBoxMobile,
              ])}
            >
              <Text>{item.description}</Text>
            </Box>
            <Box
              borderRadius="2"
              className={classNames([
                styles.descriptionBox,
                styles.descriptionBoxDesktop,
              ])}
            >
              <Text align={item.textAlign}>{item.description}</Text>
            </Box>
          </li>
        ))}
      </ul>
    </Box>
  );
};

ImpactPyramid.displayName = 'ImpactPyramid';

export default ImpactPyramid;
